module.exports = __webpack_public_path__ + "static/media/HEART-10.d8e8a657.svg";